export const enumHelper = (enumName, enumMap, field, ...rest) => {
  if (!enumMap[field]) {
    throw new TypeError(`${field} is not a valid field of ${enumName}`);
  }
  if (rest.length) {
    return rest[0] === enumMap[field];
  }
  return enumMap[field];
};
